// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cf03b733","239":"941b5512","667":"e6beb4f5"}[chunkId] + ".chunk.js";
};